module.exports = __webpack_public_path__ + "static/media/world.09f29369.png";